var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.quizData.type == "directional"
      ? _c("div", [
          _vm.quizData.renderingType == "accordion"
            ? _c(
                "div",
                [
                  _c(
                    "accordion",
                    _vm._l(this.stepData.titles, function (item) {
                      return _c(
                        "accordion-item",
                        {
                          key: item.id,
                          attrs: {
                            item: item,
                            clickable: item.current || item.answered,
                          },
                        },
                        [
                          _c("template", { slot: "accordion-trigger" }, [
                            _c("div", { staticClass: "accordion-title-left" }, [
                              _c("div", { staticClass: "orderNumber" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.orderNr) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.quizData.showStepTitle,
                                      expression: "quizData.showStepTitle",
                                    },
                                  ],
                                  staticClass: "accordion-question-label",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(item.title) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "accordion-title-and-answer" },
                              [
                                !item.current
                                  ? _c("h2", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(item.questionString) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  item.answersTitles,
                                  function (answer, index) {
                                    return _c(
                                      "button",
                                      {
                                        key: index,
                                        staticClass:
                                          "mx-2 btn btn btn-light btn-sm",
                                        attrs: {
                                          "aria-pressed": "true",
                                          color: "green",
                                          "text-color": "white",
                                          name: "answer" + index,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(answer) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: [
                                  "tick",
                                  item.answered
                                    ? "tick-answered"
                                    : "tick-notanswered",
                                ],
                              },
                              [_vm._v("✓")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "accordion-content" },
                            [
                              item.current
                                ? _c("QuestionBody", {
                                    attrs: { question: _vm.question },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm.quizData.renderingType == "legacy"
            ? _c(
                "div",
                [
                  _c("QuestionBody", { attrs: { question: _vm.question } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.quizData.showProgressBar,
                          expression: "quizData.showProgressBar",
                        },
                      ],
                      staticClass: "row",
                    },
                    [
                      _c("div", { staticClass: "stepIndicator progress" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(this.quizData.translations.step) +
                            " " +
                            _vm._s(this.stepData.currentIndex) +
                            "/" +
                            _vm._s(this.stepData.total) +
                            "\n                "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("StepsBarComponent"),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm.quizData.type == "guided"
      ? _c(
          "div",
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.quizData.showStepTitle,
                    expression: "quizData.showStepTitle",
                  },
                ],
                staticClass: "row",
              },
              [
                _c("div", { staticClass: "stepIndicator" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(this.question.stepTitle) +
                      "\n            "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("QuestionBody", { attrs: { question: _vm.question } }),
          ],
          1
        )
      : _vm.quizData.type == "counting"
      ? _c(
          "div",
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.quizData.showStepTitle,
                    expression: "quizData.showStepTitle",
                  },
                ],
                staticClass: "row",
              },
              [
                _c("div", { staticClass: "stepIndicator" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(this.question.stepTitle) +
                      "\n            "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("QuestionBody", { attrs: { question: _vm.question } }),
          ],
          1
        )
      : _vm.quizData.type == "reactive"
      ? _c("div", [
          _vm.quizData.renderingType == "accordion"
            ? _c(
                "div",
                [
                  _c(
                    "accordion",
                    _vm._l(this.stepData.titles, function (item) {
                      return _c(
                        "accordion-item",
                        {
                          key: item.id,
                          attrs: {
                            item: item,
                            clickable: item.current || item.answered,
                          },
                        },
                        [
                          _c("template", { slot: "accordion-trigger" }, [
                            _c("div", { staticClass: "accordion-title-left" }, [
                              _c("div", { staticClass: "orderNumber" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.orderNr) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.quizData.showStepTitle,
                                      expression: "quizData.showStepTitle",
                                    },
                                  ],
                                  staticClass: "accordion-question-label",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(item.title) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "accordion-title-and-answer" },
                              [
                                !item.current
                                  ? _c("h2", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(item.questionString) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  item.answersTitles,
                                  function (answer, index) {
                                    return _c(
                                      "button",
                                      {
                                        key: index,
                                        staticClass:
                                          "mx-2 btn btn btn-light btn-sm",
                                        attrs: {
                                          "aria-pressed": "true",
                                          color: "green",
                                          "text-color": "white",
                                          name: "answer" + index,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(answer) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: [
                                  "tick",
                                  item.answered
                                    ? "tick-answered"
                                    : "tick-notanswered",
                                ],
                              },
                              [_vm._v("✓")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "accordion-content" },
                            [
                              item.current
                                ? _c("QuestionBody", {
                                    attrs: { question: _vm.question },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm.quizData.renderingType == "legacy"
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.quizData.showProgressBar,
                          expression: "quizData.showProgressBar",
                        },
                      ],
                      staticClass: "row",
                    },
                    [
                      _c("div", { staticClass: "stepIndicator progress" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(this.quizData.translations.step) +
                            " " +
                            _vm._s(this.stepData.currentIndex) +
                            "/" +
                            _vm._s(this.stepData.total) +
                            "\n                "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.quizData.showStepTitle,
                          expression: "quizData.showStepTitle",
                        },
                      ],
                      staticClass: "row",
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "quizTopCTAs" },
                        _vm._l(this.stepData.titles, function (item) {
                          return _c(
                            "li",
                            {
                              key: item.id,
                              class: [
                                item.id,
                                "stepIndicator",
                                item.current ? "active" : "",
                                item.answered ? "answered" : "unanswered",
                                !_vm.quizData.navBtns && item.answered
                                  ? "answereddisabled"
                                  : "",
                              ],
                              attrs: { id: item.id, disabled: !item.answered },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.title) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("QuestionBody", { attrs: { question: _vm.question } }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }